export const navLinkStyle = {
  general: {
    textDecoration: "none",
    width: "100%",
    color: "inherit"
  }
};
